import React from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { LazyLoadImage } from 'react-lazy-load-image-component'

// Import des pictos
import picto1 from "../../images/home/Laboratoire-1-en-France-nahibu.png"
import picto2 from "../../images/home/Livraison-gratuite.png"
import picto3 from "../../images/home/Paiement-en-3x-ou-4x.png"
import picto4 from "../../images/home/Paiement-100-securise.png"

const Reassurance = ({ t }) => {
  const items = [
    { img: picto1, text: t("home|Laboratoire n°1 en France") },
    { img: picto2, text: t("home|Livraison gratuite") },
    { img: picto3, text: t("home|Paiement en 3x ou 4x") },
    { img: picto4, text: t("home|Paiement 100 % sécurisé") }
  ]

  return (
    <div className="bg-nahibu text-white py-5 mt-5">
      <Container>
        <Row className="text-center justify-content-center">
          {items.map((item, index) => (
            <Col key={index} xs={6} md={3} className="mb-4">
              <LazyLoadImage
                src={item.img}
                alt={item.text}
                width="120px"
                height="120px"
                className="mb-3"
              />
              <p className="m-0 fw-bold">{item.text}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default withTranslation()(Reassurance)
